import { render, staticRenderFns } from "./StudentNotRegistered.vue?vue&type=template&id=6d300e0d"
import script from "./StudentNotRegistered.vue?vue&type=script&lang=js"
export * from "./StudentNotRegistered.vue?vue&type=script&lang=js"
import style0 from "./StudentNotRegistered.vue?vue&type=style&index=0&id=6d300e0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports